// extracted by mini-css-extract-plugin
export default {"helpCursor":"cursor_helpCursor__4D+Rm","clickCursor":"cursor_clickCursor__l04pA","forbiddenCursor":"cursor_forbiddenCursor__Dy9Vl"};